var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotReportsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9264_7897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E52333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.399 30.774L44.125 31.0481V32.649V34.25H39.0775C34.389 34.25 33.9794 34.2629 33.3189 34.4319C30.8112 35.0732 28.8235 37.0602 28.1825 39.5663C28.0178 40.2103 28 40.6182 28 43.746C28 46.4194 28.0335 47.4289 28.1463 48.1607C29.234 55.2118 34.2597 60.8037 41.125 62.6017C42.5535 62.9757 43.8486 63.125 45.6677 63.125H47.3269L47.601 62.851L47.875 62.5769V61.25V59.9231L47.601 59.649C47.3452 59.3934 47.2778 59.3748 46.5932 59.3728C42.0047 59.3595 38.7067 58.0934 35.8692 55.2558C34.2632 53.6498 33.2178 51.9854 32.5475 49.9673C31.9386 48.1337 31.7562 46.6206 31.7546 43.3906C31.7536 41.3088 31.8486 40.513 32.1752 39.8685C32.666 38.8999 33.5854 38.2602 34.7233 38.0957C35.5787 37.972 56.4212 37.972 57.2767 38.0957C58.8259 38.3197 59.9303 39.4241 60.1543 40.9733C60.2687 41.7643 60.2725 45.0726 60.1608 46.5781C60.1148 47.1969 60.0069 48.0399 59.9209 48.4515C59.739 49.323 59.8253 49.8079 60.2072 50.0581C60.5335 50.272 62.1016 50.75 62.4766 50.75C63.2794 50.75 63.5074 50.3765 63.8131 48.561C63.9772 47.5856 64 47.0129 64 43.8651C64 40.6239 63.9826 40.2118 63.8181 39.5689C63.1767 37.061 61.19 35.0735 58.6837 34.4325C58.0199 34.2627 57.6174 34.25 52.9225 34.25H47.875V32.649V31.0481L47.601 30.774L47.3269 30.5H46H44.6731L44.399 30.774ZM38.8013 44.2002C36.8875 44.9356 36.362 47.6655 37.8483 49.1517C39.0021 50.3057 40.9979 50.3057 42.1517 49.1517C43.6499 47.6536 43.1096 44.9205 41.172 44.1956C40.4801 43.9367 39.4819 43.9387 38.8013 44.2002ZM50.8013 44.2002C48.8875 44.9356 48.362 47.6655 49.8483 49.1517C51.0021 50.3057 52.9979 50.3057 54.1517 49.1517C55.6499 47.6536 55.1096 44.9205 53.172 44.1956C52.4801 43.9367 51.4819 43.9387 50.8013 44.2002ZM59.2449 54.6172C59.1951 54.6817 58.8046 55.6128 58.3771 56.6865C57.4175 59.0963 57.0147 59.6902 55.8438 60.421C55.7148 60.5014 54.7445 60.9144 53.6875 61.3387C52.6305 61.763 51.7074 62.1661 51.6362 62.2347C51.5586 62.3094 51.5294 62.4486 51.5631 62.583C51.6111 62.7742 51.8902 62.9141 53.4738 63.5405C55.6527 64.4025 55.996 64.5851 56.7027 65.2576C57.3437 65.8677 57.6516 66.4431 58.5589 68.7266C59.2374 70.4344 59.2798 70.4986 59.6875 70.4393C59.8849 70.4105 59.8939 70.3923 60.6257 68.5344C61.4611 66.4131 61.632 66.0817 62.2262 65.4316C62.8756 64.7211 63.2241 64.5278 65.5398 63.5938C67.248 62.9048 67.5197 62.7676 67.5463 62.5808C67.5631 62.4619 67.5275 62.3052 67.4672 62.2324C67.4068 62.1597 66.5914 61.7994 65.6553 61.4317C63.5801 60.6168 62.9735 60.3026 62.4034 59.7473C61.7575 59.118 61.55 58.7367 60.7112 56.6362C60.2934 55.5902 59.9081 54.6817 59.8549 54.6172C59.8018 54.5528 59.6631 54.5 59.5469 54.5C59.4306 54.5 59.2947 54.5528 59.2449 54.6172Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9264_7897",
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9264_7897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9264_7897",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotReportsIcon);
export default __webpack_public_path__ + "static/media/ChatbotReportsIcon.6b21d0944fcfcc0dc7027f7ecc2105c0.svg";
export { ForwardRef as ReactComponent };